import Url from 'urlinator/Url'; // @ts-expect-error Untyped module

import Interframe from 'interframe'; // @ts-expect-error Untyped module

import { MessageTypes } from 'interframe/Constants';
import { SignupEmbedder, SignupEmbedderOptions } from 'signup-embedder';
import { ACKNOWLEDGE_MESSAGE_TYPE, HANDSHAKE_MESSAGE_TYPE } from 'signup-embedder/constants/MessageTypes';
import { isGoogleFallbackRedirect } from '../embedded/isGoogleFallbackRedirect';
import { isKnownDomainEmbeddingSignup } from '../embedded/isKnownDomainEmbeddingSignup';
import { getSentryExtra } from '../error/getSentryExtra';
import Logger from '../lib/Logger';
import { getMetricsCounter } from '../metrics/Metrics';
import InterframeContainer from './InterframeContainer';
const Log = Logger.getLogger('InterframeUtils');
export const onInterframeMessage = message => {
  const {
    type
  } = message; // eslint-disable-next-line default-case

  switch (type) {
    case HANDSHAKE_MESSAGE_TYPE:
      // By default we will acknowledge all handshakes from all sources
      // In the future if we want to completely disable the embedding for
      // some urls we can use this response to deny the embedding.
      InterframeContainer.getInstance().postResponse(message, {
        type: ACKNOWLEDGE_MESSAGE_TYPE
      }, MessageTypes.JSON);
      break;
  }
};
export const setupInterframe = () => {
  try {
    if (SignupEmbedder.isActive()) {
      const embeddingPage = SignupEmbedderOptions.getOptionValue(SignupEmbedderOptions.SIGNUP_EMBEDDING_PAGE_OPTION) || document.referrer;
      let embeddingPageUrl = new Url(embeddingPage); // If we are in the case of the google fallback authentication then
      // the  hostname is the domain of google authentication before the redirect.
      // In order to enable the communication between interframe and embedder,
      // use the parentUrl to pass to the interframe as the referrer.

      if (isGoogleFallbackRedirect(embeddingPageUrl.hostname)) {
        embeddingPageUrl = new Url(document.location.href);
      } // This will check if the page embedding signup contains a known domain


      if (!isKnownDomainEmbeddingSignup(embeddingPageUrl.hostname)) {
        Log.error(`The embedding page contains an unknown domain.`, {
          extra: {
            embeddingPage,
            hostname: embeddingPageUrl.hostname
          }
        });
        getMetricsCounter('embedding-page-contains-unknown-domain').increment();
      }

      const referrer = `${embeddingPageUrl.protocol}://${embeddingPageUrl.hostname}`;
      const interframe = new Interframe(referrer, SignupEmbedder.isEmbedded() ? window.parent : window.opener);
      InterframeContainer.setInstance(interframe);
      interframe.subscribe(onInterframeMessage);
      return interframe;
    }
  } catch (error) {
    Logger.getLogger('setupInteframe').error('Error while setting up interframe communication', {
      extra: getSentryExtra(error)
    });
  }

  return undefined;
};